import { defineComponent } from 'vue';

export default defineComponent({
  setup(_, { slots }) {
    if (typeof window === 'undefined') {
      return () => '<!-- -->';
    }

    return () => (slots.default ? slots.default() : '<!-- -->');
  },
});
